import React from "react";
import cname from "../../style.module.scss";
import { MeasuringSampleSpectrophotometryImage } from "../../SpectrophotometerImages";

export const Content = () => {
  return (
    <div className={cname.content}>
      <p>
        It is important to repeat the measurement with independently prepared
        samples. This replication ensures the validity of your first measurement
        and gives you an idea of the variability of your measurement.
        Replicating measurements increases the confidence you can have in your
        results and is often important for statistical analysis, which might
        even require replicating the measurement more than once.
      </p>
      <div className={cname.content_image_container}>
        <div className={cname.content_image}>
          <MeasuringSampleSpectrophotometryImage />
        </div>
      </div>
    </div>
  );
};
